<!-- Ported from the Polaris kit: src/components/ui/pagination/PaginationNext.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs.
     Change the design in the kit first, then re-port.
     Hand change (phase P): the chevron gets `rtl:rotate-180`, so it points the reading way in RTL. A re-port drops it. -->
<script setup>
import { ChevronRight16 as ChevronRightIcon } from '@carbon/icons-vue';
import { reactiveOmit } from '@vueuse/core';
import { PaginationNext, useForwardProps } from 'reka-ui';
import { cn } from '../../lib/utils';
import { buttonVariants } from '../button';

const props = defineProps({
  asChild: { type: Boolean, required: false },
  as: { type: null, required: false },
  size: { type: null, required: false, default: 'default' },
  class: {
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
});

const delegatedProps = reactiveOmit(props, 'class', 'size');
const forwarded = useForwardProps(delegatedProps);
</script>

<template>
  <PaginationNext
    data-slot="pagination-next"
    :class="
      cn(
        buttonVariants({ variant: 'ghost', size }),
        'gap-1 px-2.5 sm:pr-2.5',
        props.class
      )
    "
    v-bind="forwarded"
  >
    <slot>
      <span class="hidden sm:block">{{ $t('POLARIS.PAGINATION.NEXT') }}</span>
      <ChevronRightIcon class="rtl:rotate-180" />
    </slot>
  </PaginationNext>
</template>
